module.exports = __webpack_public_path__ + "static/ogunlewe-990a4ab096fc8b23ed45efdafbdf810b.jpg";